import * as React from 'react'

const Sledge = ({ doRotateBy180Deg = false }: { doRotateBy180Deg?: boolean }): React.ReactElement => (
  <svg viewBox="0 0 64 64" width="32" height="32" transform={doRotateBy180Deg ? 'rotate(180)' : undefined}>
    <defs>
      <style>
        {
          '.cls-2{fill:#E6564C}.cls-3{fill:#E6564C}.cls-4{fill:#408830}.cls-5{fill:#408830}.cls-10,.cls-7,.cls-8,.cls-9{fill:none}.cls-8{opacity:.16}.cls-10,.cls-13,.cls-9{stroke:#000}.cls-13,.cls-9{stroke-miterlimit:10}.cls-10,.cls-9{stroke-width:2px}.cls-10{stroke-linecap:round;stroke-linejoin:round}'
        }
      </style>
    </defs>
    <title>{'Icon Color'}</title>
    <g
      style={{
        isolation: 'isolate',
      }}
    >
      <g id="Layer_1" data-name="Layer 1">
        <g id="Vector">
          <path d="M34.32 21.18v13.43H30.33V21.18Z" className="cls-2" />
          <path
            d="M30.37 21.18v13.4c-5.61-.4-7.8-5.86-7.8-5.86a10.59 10.59 0 0 0-2-3.12v-4a1.93 1.93 0 0 1 .1-.6 2.1 2.1 0 0 0 .91.21ZM44.13 21.57v9.54a22.83 22.83 0 0 0-1.83 2.44 2.37 2.37 0 0 1-2 1.06h-6V21.18h8.79A2.22 2.22 0 0 0 44 21a1.93 1.93 0 0 1 .13.57Z"
            className="cls-3"
          />
          <path d="M30.37 13.84h3.96v7.33h-3.96z" className="cls-2" />
          <path
            d="M21.59 13.84h8.78v7.34h-8.78a2.22 2.22 0 0 1-.93-.21 2.19 2.19 0 0 1-1.26-2V16a2.18 2.18 0 0 1 2.19-2.16ZM45.3 16v3a2.2 2.2 0 0 1-2.19 2.18h-8.78v-7.34h8.78A2.18 2.18 0 0 1 45.3 16Z"
            className="cls-4"
          />
          <path d="M30.8 10.53s-6.06-5.3-7.35-.59 5.37 3.58 7.71 2.78ZM33.9 10.53s6.06-5.3 7.35-.59-5.37 3.58-7.71 2.78Z" className="cls-3" />
          <path
            d="M32 13s-3.27 2.56-3.88 9.7l-1.84-2.21-1.8 1.61s1-7.68 3.59-8.72ZM39.93 22l-1.76-1.56-1.85 2.21c-.6-7.14-3.87-9.71-3.87-9.71l3.9.34c2.56 1.03 3.58 8.72 3.58 8.72Z"
            className="cls-2"
          />
          <rect width={3.1} height={3.1} x={30.8} y={9.94} className="cls-3" rx={0.24} />
          <path d="M30 15.7a8.74 8.74 0 0 1 2-2.7l-3.9.34-.14.07-1.47 2-.29.22H30Z" className="cls-5" />
          <path d="M30.37 13.84h3.96v1.86h-3.96z" className="cls-5" />
          <path d="m36.35 13.26-3.9-.34a8.84 8.84 0 0 1 2 2.78h3.8a4.49 4.49 0 0 0-1.9-2.44Z" className="cls-5" />
          <path
            d="M63.61 37.59v11.59a5 5 0 0 1-5 4.83H8.5A8.14 8.14 0 0 1 .39 45.9v-.7a3.09 3.09 0 0 1 3.1-3.09H7.3v3.79a3.09 3.09 0 0 0 3.09 3.1h43.22a3.08 3.08 0 0 0 3.08-3.09v-5.23a3.09 3.09 0 0 1 3.1-3.09Z"
            className="cls-3"
          />
          <path d="m20.02 42.42-2.79 6.57h-5.14l3.05-7.2h3.41l1.47.63zM50.52 48.99h-5.14l-2.8-6.57 1.47-.63h3.4l3.07 7.2z" className="cls-3" />
          <path
            d="m55.7 28.5-3.43 10.08a4.93 4.93 0 0 1-4.72 3.21h-33a4.92 4.92 0 0 1-4.75-3.21L3.55 20.22a2.37 2.37 0 0 1 3.09-3c4.29 1.64 10.5 4.52 13.93 8.36a10.59 10.59 0 0 1 2 3.12s2.19 5.46 7.8 5.86h9.94a2.37 2.37 0 0 0 2-1.06 22.83 22.83 0 0 1 1.83-2.44A16.44 16.44 0 0 1 53 25.4a2.37 2.37 0 0 1 2.7 3.1Z"
            style={{
              fill: '#E6A64C',
            }}
          />
          <path d="M34.32 21.18v13.43H30.33V21.18Z" className="cls-7" />
          <path
            d="M30.37 34.58v-13.4h-8.79a2.18 2.18 0 0 1-.92-.21 1.93 1.93 0 0 0-.09.6v4M44.13 21.57v9.54a22.83 22.83 0 0 0-1.83 2.44 2.37 2.37 0 0 1-2 1.06h-6V21.18h8.79A2.22 2.22 0 0 0 44 21a1.93 1.93 0 0 1 .13.57ZM30.37 13.84h3.96v7.33h-3.96z"
            className="cls-7"
          />
          <path
            d="M21.59 13.84h8.78v7.34h-8.78a2.22 2.22 0 0 1-.93-.21 2.19 2.19 0 0 1-1.26-2V16a2.18 2.18 0 0 1 2.19-2.16ZM45.3 16v3a2.2 2.2 0 0 1-2.19 2.18h-8.78v-7.34h8.78A2.18 2.18 0 0 1 45.3 16Z"
            className="cls-7"
          />
          <path d="M30.8 10.53s-6.06-5.3-7.35-.59 5.37 3.58 7.71 2.78M33.9 10.53s6.06-5.3 7.35-.59-5.37 3.58-7.71 2.78" className="cls-7" />
          <path
            d="M32 13s-3.27 2.56-3.88 9.7l-1.84-2.21-1.8 1.61s1-7.68 3.59-8.72ZM39.93 22l-1.76-1.56-1.85 2.21c-.6-7.14-3.87-9.71-3.87-9.71l3.9.34c2.56 1.03 3.58 8.72 3.58 8.72Z"
            className="cls-7"
          />
          <rect width={3.1} height={3.1} x={30.8} y={9.94} className="cls-7" rx={0.24} />
          <path
            d="M35.8 9.4a3.94 3.94 0 0 1 .78 3.9l-2.66-.58.37-2.19A14.17 14.17 0 0 1 35.8 9.4ZM19.4 17.62v1.66A1.87 1.87 0 0 0 20.63 21l4.05-.23.17-5h-3.6a2.15 2.15 0 0 0-1.85 1.92Z"
            className="cls-8"
          />
        </g>
        <g id="Line">
          <path
            d="M27 54H8.5a8.14 8.14 0 0 1-8.11-8.1v-.7a3.09 3.09 0 0 1 3.1-3.09H7.3v3.79a3.09 3.09 0 0 0 3.09 3.1h43.22a3.08 3.08 0 0 0 3.08-3.09v-5.23a3.09 3.09 0 0 1 3.1-3.09h3.82v11.59a5 5 0 0 1-5 4.83H33"
            className="cls-9"
          />
          <path d="m20.02 42.42-2.79 6.57h-5.14l3.05-7.2h3.41l1.47.63zM50.52 48.99h-5.14l-2.8-6.57 1.47-.63h3.4l3.07 7.2z" className="cls-9" />
          <path
            d="m6 27.41-2.45-7.19a2.37 2.37 0 0 1 3.09-3c4.29 1.64 10.5 4.52 13.93 8.36a10.59 10.59 0 0 1 2 3.12s2.19 5.46 7.8 5.86h9.94a2.37 2.37 0 0 0 2-1.06 22.83 22.83 0 0 1 1.83-2.44A16.44 16.44 0 0 1 53 25.4a2.37 2.37 0 0 1 2.71 3.1l-3.44 10.08a4.93 4.93 0 0 1-4.72 3.21h-33a4.92 4.92 0 0 1-4.75-3.21L7.22 31"
            className="cls-9"
          />
          <path d="M34.32 21.18v13.43H30.33V21.18Z" className="cls-10" />
          <path
            d="M30.37 34.58v-13.4h-8.79a2.18 2.18 0 0 1-.92-.21 1.93 1.93 0 0 0-.09.6v4M44.13 21.57v9.54a22.83 22.83 0 0 0-1.83 2.44 2.37 2.37 0 0 1-2 1.06h-6V21.18h8.79A2.22 2.22 0 0 0 44 21a1.93 1.93 0 0 1 .13.57ZM30.37 13.84h3.96v7.33h-3.96z"
            className="cls-10"
          />
          <path
            d="M21.59 13.84h8.78v7.34h-8.78a2.22 2.22 0 0 1-.93-.21 2.19 2.19 0 0 1-1.26-2V16a2.18 2.18 0 0 1 2.19-2.16ZM45.3 16v3a2.2 2.2 0 0 1-2.19 2.18h-8.78v-7.34h8.78A2.18 2.18 0 0 1 45.3 16Z"
            className="cls-10"
          />
          <path d="M30.8 10.53s-6.06-5.3-7.35-.59 5.37 3.58 7.71 2.78M33.9 10.53s6.06-5.3 7.35-.59-5.37 3.58-7.71 2.78" className="cls-10" />
          <path
            d="M32 13s-3.27 2.56-3.88 9.7l-1.84-2.21-1.8 1.61s1-7.68 3.59-8.72ZM39.93 22l-1.76-1.56-1.85 2.21c-.6-7.14-3.87-9.71-3.87-9.71l3.9.34c2.56 1.03 3.58 8.72 3.58 8.72Z"
            className="cls-10"
          />
          <rect width={3.1} height={3.1} x={30.8} y={9.94} className="cls-10" rx={0.24} />
        </g>
        <g
          style={{
            mixBlendMode: 'multiply',
          }}
        >
          <g
            id="Shadow"
            style={{
              opacity: 0.25,
              mixBlendMode: 'multiply',
            }}
          >
            <path
              d="M36.93 13.41c2.55.21 5.17-.35 4.32-3.47-.77-2.82-3.25-2-5.11-1 .3 1.49.57 2.98.79 4.47ZM63.6 49.18V37.59h-3.81a3.09 3.09 0 0 0-3.09 3.09v5.22a3.09 3.09 0 0 1-3.09 3.1h-3.09l-3.06-7.2h.09a4.93 4.93 0 0 0 4.73-3.21l3.43-10.09A2.38 2.38 0 0 0 53 25.4a16.37 16.37 0 0 0-8.85 5.71v-9.54A1.93 1.93 0 0 0 44 21a2.16 2.16 0 0 1-.93.21A2.2 2.2 0 0 0 45.3 19v-3a2.18 2.18 0 0 0-2.19-2.18h-6c0-.06-.11-.1-.17-.16.36 2.49.62 5 .75 7.5.07 1.54.11 3.09.1 4.63 0 4.64-.49 9.37-2.3 13.64a19.79 19.79 0 0 1-1.19 2.34h9.72l-1.47.63 2.83 6.6H26.24l-.21.09c-4.34 1.53-9.32.77-13.44 2.82A10.25 10.25 0 0 0 9.73 54H58.6a5 5 0 0 0 5-4.82Z"
              className="cls-13"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export default Sledge
